import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, NgForm } from '@angular/forms';
import { AngularTokenService } from 'angular-token';
import { environment } from '../../../environments/environment';
import { Router }     from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss']
})
export class EmailConfirmationComponent implements OnInit {
  
  resendEmailForm: FormGroup;

  constructor(
    private tokenService: AngularTokenService,
    private formBuilder: FormBuilder,
    public router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.resendEmailForm = new FormGroup({
      'email': new FormControl("", Validators.required)
    });
  }

  onSubmit(form) {
    let url = environment.apiBaseUrl+'/auth/confirmation';
    let redirectUrl = environment.uiBaseUrl+'/login';
    this.http.post(url, {email: form.value.email, redirect_url: redirectUrl}).subscribe(
      res => {
        console.log(res);
        this.router.navigate(['/email-confirmation-instructions-success']);
        this.toastr.success("Confirmation instructions sent to your email.");
      },
      err => {
        console.log(err);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    )
  }

}
